import ModelUtil from '@leverege/model-util';
import Formatters from "../../attribute/formatter/Formatters.js";
import TimestampFormatterModel from "../../attribute/formatter/TimestampFormatterModel.js";
function create(type, extend) {
  return {
    type,
    header: {
      label: null
    },
    emptyValue: '',
    ...extend
  };
}
export default {
  create,
  ...ModelUtil.createAllValue('header/label', 'headerLabel'),
  ...ModelUtil.createAllValue('emptyValue'),
  renderText(value, model) {
    if (value == null) {
      return model.emptyValue;
    }
    let formatter = model.formatter;
    if (!model.customFormat && model?.unitType === 'timestamp') {
      formatter = TimestampFormatterModel.setFormat(formatter, 'iso8601');
    }
    const formatted = Formatters.format(value, formatter);
    return formatted.join(' ');
  },
  rawValue(value, model) {
    if (value == null) {
      return model.emptyValue;
    }
    let formatter = model.formatter;
    if (!model.customFormat && model?.unitType === 'timestamp') {
      formatter = TimestampFormatterModel.setFormat(formatter, 'iso8601');
    }
    if (formatter) {
      const formatted = Formatters.format(value, {
        ...formatter,
        singleLine: true
      });
      return formatted[0];
    }
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    return value;
  }
};